import React from 'react';
import isEmpty from 'lodash/isEmpty';
import promoData from 'core/modules/Sweeps/utils/promoData';
import SweepsInactive from 'core/modules/Sweeps/components/SweepsInactive/SweepsInactive';

import './Sweeps.scss';

function SweepsRules() {
  const sweepsData = promoData.sweepsDataJson;

  if (isEmpty(sweepsData)) {
    return <SweepsInactive />;
  }

  return (
    <div className="mn_sweepsRulesContent">
      <div className="mn_contentWrap">
        <div dangerouslySetInnerHTML={{ __html: sweepsData.fullTerms }} />
      </div>
    </div>
  );
}

export default SweepsRules;
